<template>
  <div class="price-div pa-5 w-100">
    <div>
      <div v-if="variantsStocks > 0" class="d-flex align-items-center">
        <div class="green-iconBox">
          <v-icon large>$BoxChecked2</v-icon>
        </div>
        <span class="fs-large ms-1"> موجود در انبار </span>
      </div>
      <div class="d-flex align-items-center" v-else>
        <div class="red-iconBox">
          <v-icon large class="box-empty">$BoxEmpty</v-icon>
        </div>
        <span class="fs-large ms-2 error--text">ناموجود </span>
      </div>
    </div>

    <div class="d-flex justify-space-between mt-4 mx-1">
      <h6 class="mainFont--text fs-large">قیمت</h6>
      <div
        v-if="details.specialPrice == details.price"
        class="sub_price_discont_box"
      >
        <h5 class="shopPrimary--text">
          {{ Number(details.price).toLocaleString() }} تومان
        </h5>
      </div>
      <div class="root_column" v-else>
        <div class="price_discont_box">
          <del class="sub_price_discont_box">
            <h5 class="mainFont--text">
              {{ Number(details.price).toLocaleString() }} تومان
            </h5>
          </del>
          <div class="box_discount-slider">
            <span> {{ details.discountPercentage }}% </span>
          </div>
        </div>
        <div class="sub_price_discont_box">
          <h5 class="shopPrimary--text">
            {{ Number(details.specialPrice).toLocaleString() }} تومان
          </h5>
        </div>
      </div>
    </div>
    <div>
      <div v-if="productIndexInCart < 0 || !cart[productIndexInCart].amount">
        <v-btn
          block
          height="44"
          class="primary d-flex justify-center mt-2"
          :loading="loading"
          :disabled="variantsStocks <= 0"
          @click="addToCart(details)"
        >
          <span>افزودن به سبد خرید</span>
        </v-btn>
      </div>

      <div class="d-felx justify-space-between mx-auto" v-else>
        <div
          v-if="loading"
          class="text-center py-1 d-felx justify-space-between mx-auto"
        >
          <v-progress-circular
            indeterminate
            size="20"
            color="#a076f9"
            class="mx-auto"
            style="margin-top: 2px"
          ></v-progress-circular>
        </div>
        <div class="root_column d-flex flex-column align-center" v-else>
          <product-counter
            class="operations text-center mt-2 w-100"
            :item="cart.filter((x) => x.id == details.id)[0]"
            :index="cart.findIndex((x) => x.id == details.id)"
            :usage="'store'"
            :cart-id="cartId"
            @send-amount="handleAmount"
          />
          <!--          <div class="card_counter_product">
            <div class="btn_basket_Cart" @click="addToCart(details)">
              <v-icon class="primary&#45;&#45;text pointer text-center"
                >mdi-plus</v-icon
              >
            </div>
            <v-divider vertical class="primary"></v-divider>
            <span
              class="item_shopping_Cart primary&#45;&#45;text"
              v-if="cart[productIndexInCart].amount"
            >
              {{
                cart[productIndexInCart].amount
                  ? cart[productIndexInCart].amount
                  : ""
              }}
            </span>
            <v-divider vertical class="primary"></v-divider>
            <div class="btn_basket_Cart" @click="removeItem(details, index)">
              <v-icon
                v-if="cart[productIndexInCart].amount > 1"
                class="primary&#45;&#45;text pointer text-center"
              >
                mdi-minus</v-icon
              >
              <v-icon
                v-else-if="cart[productIndexInCart].amount === 1"
                class="primary&#45;&#45;text pointer text-center"
              >
                mdi-delete-outline
              </v-icon>
            </div>
          </div>-->
          <div v-if="!loading" style="width: 100%">
            <v-btn
              class="primary d-flex justify-center mt-2"
              height="44"
              type="submit"
              :loading="loading"
              @click="goToCheckout()"
              style="width: 100%"
            >
              تسویه حساب
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import { mapState } from "vuex";
import ProductCounter from "../../../../components/OnlineShop/ProductCounter";

export default {
  name: "ProductSideBar",
  components: { ProductCounter },
  props: ["details", "variantsStocks"],
  data() {
    return {
      loading: false,
      cartId: "",

      // cartData: [],
      isInCartResponse: false,
      // isLoading: true,
    };
  },
  methods: {
    handleAmount(event) {
      this.details.amountInCart = event;
    },
    // getCartData: async function () {
    //   this.isLoading = true;
    //   await Axios.get(
    //     this.baseUrl + "/onlineShop/cart/getData/" + this.cartId,
    //     {
    //       headers: {
    //         Authorization: "Bearer: " + localStorage.getItem("shopToken"),
    //       },
    //     }
    //   )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         this.cartData = res.data;
    //         if (this.cartData.items.length == 0) {
    //         }
    //         this.loading = false;
    //         this.isLoading = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.isLoading = false;
    //       this.loading = false;
    //       if (err.response.status == 403 || err.response.status == 404)
    //         localStorage.setItem("name", "");
    //       else this.toast.error("خطا: " + err.response.data);
    //     });
    // },
    removeItem: async function (item) {
      this.loading = true;
      await Axios.post(
        this.baseUrl + "/onlineShop/cart/removeItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status === 200) {
            this.loading = false;
            this.$store.dispatch("getCartData", {
              cartId: this.cartId,
              id: this.details.id,
            });
            this.toast(res.data.message, "success");
            this.cart[this.productIndexInCart].amount--;
            // this.getCartData();
            this.loading = false;
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addToCart(details) {
      if (localStorage.getItem("shopToken")) {
        this.loading = true;
        Axios.post(
          this.baseUrl + "/onlineShop/cart/addItem/" + this.cartId,
          {
            amount: 1,
            warehouseItemId: details.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("shopToken"),
            },
          }
        )
          .then((res) => {
            if (res.status === 200) {
              this.$store.dispatch("getCartData", {
                cartId: this.cartId,
                id: this.details.id,
              });
              this.toast(res.data.message, "success");
              // this.getCartData();
            } else {
              this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            }
            this.loading = false;
          })
          .catch((err) => {
            this.toast(err.response, "error");
          });
      } else {
        this.toast(
          "برای افزودن محصول به سبد خرید ابتدا ثبت نام یا ورود کنید",
          "error"
        );
      }
    },
    goToCheckout() {
      this.$router.push("/checkout/cart");
    },
  },
  mounted() {
    this.cartId = localStorage.getItem("cartId");
    // this.getCartData();
    this.$store.dispatch("getCartData", {
      cartId: this.cartId,
      id: this.details.id,
    });
  },
  computed: {
    ...mapState({
      cart: (state) => state.onlineShop.cart,
      isLoading: (state) => state.onlineShop.isLoading,
      productIndexInCart: (state) => state.onlineShop.productIndexInCart,
    }),
  },
};
</script>

<style lang="scss">
.box_discount-slider {
  width: 30px;
  height: 30px;
  background: #d50000;
  border-radius: 5px;
  color: white;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.select_product_details {
  background-color: #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 250px;
}

.text_select_product {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 10px 0;

  h6 {
    font-weight: 600;
    font-size: 22px;
    color: var(--mainFont);
  }
}

.sub_price_discont_box {
  h5 {
    color: var(--mainFont);
  }
}

.price_discont_box {
  display: flex;
}

.item_shopping_Cart {
  font-size: 18px;
  font-weight: 600;
  padding: 12px;
}

.card_counter_product {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 35px;
  border: 1px solid #7c4dff;
  border-radius: 8px;
  background: #fff;
}

.btn_basket_Cart {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

@media only screen and (min-width: 1280px) {
  .btn_basket_Cart {
    width: 35px;
    height: 35px;
  }

  .item_shopping_Cart {
    font-size: 16px;
  }
}

@media only screen and (max-width: 1024px) {
  .card_counter_product {
    align-self: center !important;
  }
}

@media only screen and (max-width: 600px) {
  .select_product_details {
    padding: 10px;
  }

  .title_details_product {
    text-align: center;

    h1 {
      font-weight: 600;
      font-size: 18px;
    }
  }

  .text_select_product {
    display: flex;
    flex-direction: column;
    align-items: center;

    h6 {
      font-weight: 600;
      font-size: 18px;
    }
  }

  .sub_price_discont_box {
    display: flex;
    align-items: center;
  }

  .btn_select_product {
    font-size: 14px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
